var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSystem4(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "system4_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .225h80v80H0v-80z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#system4_svg__a)",
    stroke: "#504FE9",
    strokeWidth: 2.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.465 15.33a5 5 0 11-7.07-7.07 5 5 0 017.07 7.07zM17.606 72.19a5 5 0 11-7.071-7.07 5 5 0 017.07 7.07zM32.42 77.915c2.45.49 4.985.747 7.58.747 21.228 0 38.438-17.209 38.438-38.437a38.28 38.28 0 00-8.742-24.406M47.653 2.549A38.615 38.615 0 0040 1.787c-21.228 0-38.438 17.209-38.438 38.437a38.28 38.28 0 008.742 24.406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 51.573c-6.268 0-11.349-5.08-11.349-11.348 0-6.268 5.081-11.349 11.349-11.349 6.267 0 11.348 5.081 11.348 11.349 0 6.267-5.08 11.348-11.348 11.348zm22.63-16.247a23.017 23.017 0 00-3.175-7.663l2.994-2.993-6.91-6.906-2.992 2.991a23.014 23.014 0 00-7.662-3.175v-4.23h-9.77v4.23a23.013 23.013 0 00-7.662 3.175l-2.992-2.991-6.91 6.906 2.993 2.993a23.015 23.015 0 00-3.175 7.663h-4.242l-.005 9.77h4.247a23.018 23.018 0 003.175 7.662l-3.005 3.005 6.906 6.911 3.007-3.008a23.015 23.015 0 007.663 3.175V67.1h9.77V62.84a23.015 23.015 0 007.662-3.175l3.008 3.008 6.906-6.911-3.006-3.005a23.016 23.016 0 003.175-7.663h4.247v-9.77H62.63z"
  }))));
}
export default SvgSystem4;